import { C } from "../styles";

export default function Boot() {
    return (
        <div
            style={{
                minHeight: "100vh",
                background: C.bg,
                color: C.muted,
                fontFamily: C.font,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 12,
                letterSpacing: "0.3em",
            }}
            data-testid="boot-screen"
        >
            LOADING VAULT…
        </div>
    );
}
